import {
  HubPage, Container, SectionHead, CategoryCard, ResourceCard, FeaturedCard,
  CommunityCTA, BetaCTA, Band, HeroMedia, Seo,
} from "../components/hub/HubKit";
import { CATEGORIES, RESOURCES, featuredResources, PAGE_IMAGES } from "../data/hub";

export default function Resources() {
  const featured = featuredResources();
  return (
    <HubPage testid="resources-page">
      <Seo
        title="Everyday Resources — Practical, Gentle Guides | HEARD"
        description="Short, warm, and useful guides for everyday life across eight categories — health, food, family, relationships, work & money, home, grief, and joy."
      />

      {/* Category-first hero */}
      <Container className="pt-14 pb-10 sm:pt-20">
        <div className="grid items-center gap-8 lg:grid-cols-[1fr_0.82fr]">
          <SectionHead overline="Everyday Resources" title="Start with what your day looks like." sub="Eight gentle areas of everyday life — each with practical guides grounded in care, not perfection." />
          <HeroMedia src={PAGE_IMAGES.resources} alt="A calm, warm cup of tea beside soft botanicals in natural light" eager className="aspect-[16/10] lg:aspect-[5/4]" />
        </div>
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CATEGORIES.map((c) => <CategoryCard key={c.slug} cat={c} />)}
        </div>
      </Container>

      {/* Featured guides */}
      {featured.length > 0 && (
        <Band tone="white" className="border-y border-line/60 py-14 sm:py-20">
          <Container>
            <h2 className="serif-display text-2xl text-charcoal">Featured guides</h2>
            <div className="mt-6" data-testid="resources-featured">
              {featured[0] && <FeaturedCard resource={featured[0]} />}
              {featured.length > 1 && (
                <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
                  {featured.slice(1).map((r) => <ResourceCard key={r.slug} resource={r} />)}
                </div>
              )}
            </div>
          </Container>
        </Band>
      )}

      {/* All resources */}
      <Container className="py-14 sm:py-20">
        <h2 className="serif-display text-2xl text-charcoal">All resources</h2>
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-testid="resources-all">
          {RESOURCES.map((r) => <ResourceCard key={r.slug} resource={r} />)}
        </div>
      </Container>

      <Band tone="deep" className="py-14 sm:py-20">
        <Container>
          <BetaCTA />
          <div className="mt-8"><CommunityCTA /></div>
        </Container>
      </Band>
    </HubPage>
  );
}
